export default __webpack_public_path__ + "fonts/adb1ef273c9971368eab9dd4b885c57d.svg";